import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {GET_FILE_URL} from '../../../onboarding/core/_requests'
import {useNavigate} from 'react-router'

export const DisplayImage = ({
  imgName,
  isUserAvatarWithLetter = false,
  height,
  alt,
  width,
  fit,
  className,
  onClickPath,
  type,
  customUrl,
}: {
  imgName: string | undefined
  isUserAvatarWithLetter?: boolean
  height?: string | number
  alt: string | undefined
  width?: string | undefined | number
  className?: string
  fit?: 'fill' | 'cover' | 'contain'
  onClickPath?: string
  type?: string
  customUrl?: string
}) => {
  const [imageValid, setImageValid] = useState(false)
  const navigate = useNavigate()
  const checkImageValidity = (url: string) => {
    const img = new Image()
    img.src = url
    img.onload = () => {
      setImageValid(true)
    }
    img.onerror = () => {
      setImageValid(false)
    }
  }
  useEffect(() => {
    if (imgName) {
      checkImageValidity(`${GET_FILE_URL}/${encodeURIComponent(imgName || '')}`)
    }
  }, [imgName])

  return (
    <>
      {isUserAvatarWithLetter ? (
        <div
          className={`c-profile d-flex justify-content-center align-items-center bg-primary border-primary text-white`}
        >
          {imgName?.slice(0, 1).toUpperCase()}
        </div>
      ) : (
        <>
          {imageValid ? (
            <img
              src={`${GET_FILE_URL}/${encodeURIComponent(imgName || '')}`}
              height={height}
              width={width}
              alt={alt}
              style={{objectFit: fit}}
              className={className}
              onClick={() => {
                if (onClickPath) {
                  navigate(onClickPath)
                }
              }}
            />
          ) : type === 'featured' ? (
            <img
              src={toAbsoluteUrl('/media/icons/duotune/general/featured-copy.png')}
              width='72.7px'
              height='46.29px'
              alt={alt}
              style={{objectFit: fit}}
              className={className}
              onClick={() => {
                if (onClickPath) {
                  navigate(onClickPath)
                }
              }}
            />
          ) : type === 'custom' ? (
            <img
              src={toAbsoluteUrl(`/media/icons/duotune/general/${customUrl}`)}
              width={width}
              height={height}
              alt={alt}
              style={{objectFit: fit}}
              className={className}
              onClick={() => {
                if (onClickPath) {
                  navigate(onClickPath)
                }
              }}
            />
          ) : (
            <img
              src={toAbsoluteUrl('/media/icons/duotune/general/user1.svg')}
              width={width}
              height={height}
              alt={alt}
              style={{objectFit: fit}}
              className={className}
              onClick={() => {
                if (onClickPath) {
                  navigate(onClickPath)
                }
              }}
            />
          )}
        </>
      )}
    </>
  )
}
